import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'
import Ws from '../providers/Ws';

export default class CosturiTipuriList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            strSearchString:'',
            elementeAfisate:[],
            numeInsert:''
            
        } 
    }



    componentDidMount(){
       this.setState({ elementeAfisate:this.props.elemente || []})
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        if(tx !== null){

            return tx.substring(0,1).toUpperCase()
        }
    }

    filterFunc = (ev) => {

        this.setState({strSearchString:ev.target.value})
        let e = [...this.props.elemente]

        e = e.filter(x=>{
            
            if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            return false

        })

        this.setState({elementeAfisate: e})
    }

    insertTip = async()=>{
        let ws = new Ws();

        // console.log('nume tip cost :', this.state.numeInsert);

        let insert = await ws.insert('proiecte_costuri_tipuri', {nume:this.state.numeInsert} )
        
        if(insert.Succes){
            this.setState({numeInsert:''})
            this.props.getTipuriCost()
        }
    }
    render(){
        return (
            <div className='pm-users-list-container'>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{cursor:this.props.dialogDisplay === 1 ? "initial" : 'pointer', position:'relative'}} className='pm-list-container'>
                <li className='pm-list-item-user' >
                                   
                                   <Grid container style={{justifyContent:'left'}} className='pm-list-container-avatar'>
                                   
                                       <Grid style={{position:'relative'}} item xs={7} sm={7} md={7} lg={7} xl={7} className='pm-list-item-avatar'>
                                       <div className='pm-list-borderleft'></div>
                                       <input placeholder='Adauga Nume' style={{backgroundColor:'transparent'}}  className='pm-task-time-input' type='text' value={this.state.numeInsert}  onChange={(ev)=>{this.setState({numeInsert:ev.target.value})}} /> 
                         
                                       </Grid>
   
   
                                       <Grid style={{justifyContent:'left'}} onClick={this.insertTip} style={{borderRight:'none', cursor:'pointer'}} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                       
                                       <span   className='pm-list-item-span'><i style={{color:'#10aa2ac5'}} className='material-icons'>add</i></span>
                         
                                       </Grid>
   
                       
                                       
                                      
                                   </Grid>
                                      
                                   </li>
                  
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li className='pm-list-item-user' key={idx}  >
                                   
                                <Grid container style={{justifyContent:'left'}} className='pm-list-container-avatar'>
                                
                                    <Grid style={{position:'relative'}} item xs={7} sm={7} md={7} lg={7} xl={7} className='pm-list-item-avatar'>
                                    <div className='pm-list-borderleft'></div>
                                    <span   className='pm-list-item-span'>{e[this.props.onlyColumns.nume]}</span>
                      
                                    </Grid>


                                    <Grid style={{justifyContent:'left'}} onClick={()=>{this.props.onElClick(e)}} style={{borderRight:'none', cursor:'pointer'}} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                    
                                    <span   className='pm-list-item-span'><i style={{color:'#10aa2ac5'}} className='material-icons'>add</i></span>
                      
                                    </Grid>

                    
                                    
                                   
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


CosturiTipuriList.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    onElClick:PropTypes.func

}